/* eslint-disable @next/next/no-img-element */
"use client";
import cn from "clsx";
import ScoreRating from "./scoreRating";
import UKToast from "@/components/UKToast";
import CustomTextarea from "./customTextArea";
import SecondaryReplyList from "./SecondaryReplyList";
import NoCheckPsd from "@/assets/icons/NoCheckPsd.svg";
// import PreviewImageVideo from "@/components/previewImageVideo";
import PreviewImageVideo from "@/app/csr-src/components/previewImageVideo";
import CommentBottomDetailOpts from "./commentBottomDetailOpts";
import VideoPay from "@/components/videoDom/icons/videoPay_top.svg";

import { avatarFn } from "@/utils";
import { useStores } from "@/models";
import { Avatar } from "@mui/material";
import { useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { callAfterLogin, JDILogin } from "@/lib/jdiClientUtils";
import { IntlDialog, SubmitButton } from "@/components/intlMui";
import { imageUtil } from "@/common-components-src/js/utils/imageUtil";
import { getInitCommentDetailPage, publishReplyComment } from "@/apis/service";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
import { EXPOSURE_RECORD as REVIEW_LIST_EXPOSURE_RECORD, sendClickTrack as reviewListSendClickTrack } from "@/tracks/25338";
import { sendClickTrack as reviewDetailSendClickTrack } from "@/tracks/25347";
 
const CommentItem = observer(
  ({
    comment, // 评论数据
    commentOpts, // 评论配置
    reportReqParams, // 举报参数
    showReply = false, // 是否展示回复
    limitReplyCount = 1, // 回复限制条数
    showReplyList = false, // 是否展示回复列表
    isShowScoreStar = false, // 是否展示评分
    showCommentMedia = false, // 是否展示评论媒体
    isLimitReplyCount = false, // 是否限制回复条数
    showMoreReplyList = false, // 是否展示更多回复
    isHandleCommentClick = true, // 是否处理评论点击
  }: any) => {
    const { commentSku, commentDate, content, imageList = [], videoList = [], replyList, propertyExt, skuId, star } = comment;
    const rootStore = useStores(); // 全局store
    const currentRef = useRef<any>(); // 当前评论回复输入框
    const { commentNum } = commentOpts; // 评论数量
    const [imageUrl, setImageUrl] = useState(""); // 预览图片视频url
    const [openImage, setOpenImage] = useState(false); // 预览图片视频弹窗
    const {commentId, parentReplyId = 0} = reportReqParams; // 评论id 和 父级回复id
    const [replyContent, setReplyContent] = useState<string>(""); // 评论回复内容
    const [previewParams, setPreviewParams] = useState<any>({}); // 预览图片视频参数
    const [customReplyList, setCustomReplyList] = useState<any[]>(); // 自定义回复列表
    const [reviewDetailData, setReviewDetailData] = useState<any>(); // 评论详情数据
    const [isOpenReviewDetail, setIsOpenReviewDetail] = useState<boolean>(false); // 是否打开评论详情弹窗
    const [isCommentItemDelete, setIsCommentItemDelete] = useState<boolean>(false); // 是否删除评论

    // 获取评论用户信息
    const {
      userImage: newUserImage = comment.userImage,
      nickName: newUserNickName = comment.userNickName,
      isAnoymous: anonymousFlag = commentOpts.anonymousFlag,
    } = rootStore.commentOpstsStore?.anonymous?.get(commentId) || {};
    // 查看评论详情， 获取评论详情数据
    const showReviewDetail = async () => {
      const res = await getInitCommentDetailPage({ commentId, parentReplyId: parentReplyId ?? 0, skuId });
      if (res && res.success) {
        setReviewDetailData(res?.data || {});
      }
      setIsOpenReviewDetail(true);
    };
    // 评论回复输入框内容改变
    const onTextareaChange = (value: string) => {
      setReplyContent(value);
    };
    // 提交评论回复
    const submitReply = async () => {
      const parentContainer = currentRef?.current?.closest(".MuiDialog-container");
      if (parentContainer) {
        parentContainer.removeAttribute("tabindex");
      }

      callAfterLogin(async () => {
        const userInfo = await JDILogin.getInstance().getUserInfo();
        if (userInfo.isLoggedIn) {
          const res = await publishReplyComment({
            commentId,
            parentReplyId: 0,
            content: replyContent,
            anonymousFlag: false,
          });
          const { saveResult, ...rest } = res?.data || {};
          if (saveResult) {
            setCustomReplyList([
              {
                ...(rest || {}),
                content: replyContent,
                canDelete: true,
              },
              ...(customReplyList || []),
            ]);
            setReplyContent("");
          } else {
            UKToast.show({
              icon: "error",
              content: res.msg,
            });
          }
        }
      });
    };
    // 删除评论
    const onCommentDelete = () => {
      setIsCommentItemDelete(true);
      setIsOpenReviewDetail(false);
    };
    // 关闭预览图片视频组件
    const closeReviewDetail = () => {
      setPreviewParams({});
      setIsOpenReviewDetail(false);
      setOpenImage(false);
    };
    // 匿名回调
    const setAnonymousFn = (v: any) => {
      rootStore.commentOpstsStore?.changeAnonymousState(commentId, v);
    };
    // 图片视频预览匿名
    const anonymousFn = (v: any) => {
      showReviewDetail();
    }
    // 预览图片视频
    const preViewImageVideoFn = (url: string, type: number) => {
      setOpenImage(true);
    };
    if (isCommentItemDelete) {
      return null;
    }
    return (
      <div className="intl-comment-item"
        onClick={() => {
          reviewListSendClickTrack.Productdetail_Comment_Card({ skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}`, index: commentNum })
        }}
      >
        <div className="reviews-item-block">
          <div className="reviews-item">
            <div style={{ marginRight: "6px" }}>
              <Avatar
                sizes="36"
                src={avatarFn(newUserImage) || ""}
                alt=""
                slotProps={{
                  img: {
                    loading: "lazy",
                  },
                }}
                sx={{
                  bgcolor: "#E1E3E6",
                  "& .MuiSvgIcon-root": {
                    width: "100%",
                    height: "100%",
                    fill: "#F0F1F2",
                  },
                }}
              />
            </div>
            <div className="basic-font reviews-msg new-basic">
              <div className="reviews-name">
                <span className="nick-name">{newUserNickName}</span>
                {isShowScoreStar && <ScoreRating value={star} size={14} starOnly />}
              </div>
              <div className="reviews-date">
                <span style={{ marginRight: "20px" }}>{commentSku?.propertyExt || propertyExt}</span>
                <span>{commentDate}</span>
              </div>
            </div>
          </div>
          <p className={cn("reviews-content", isShowScoreStar ? "":"reviews-content-text")}> {content}</p>
          {/* 商详评论媒体 */}
          {showCommentMedia && (
            <div className="media-zone">
              {videoList?.map((item: any, index: number) => (
                <div key={index} style={{ width: "140px", height: "140px", position: "relative" }}>
                  <video
                    style={{ width: "140px", height: "140px", objectFit: "cover", cursor: "pointer" }}
                    src={item.videoUrl ? item.videoUrl : ""}
                    onClick={() => {
                      reviewListSendClickTrack.Productdetail_Comment__Picture({skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}`, material_type: "2" })
                      reviewDetailSendClickTrack.Evaluate_CommentDetail_Picture({material_type: "2", skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}` })

                      preViewImageVideoFn(item.videoUrl, 0);
                      setImageUrl(item.videoUrl);
                      setPreviewParams({
                        currentUserOperation: commentOpts?.currentUserOperation,
                        anonymousFlag: commentOpts?.anonymousFlag,
                      })
                    }}
                  ></video>
                  <VideoPay style={{ position: "absolute", top: "10px", left: "10px" }} />
                </div>
              ))}
              {imageList?.map((_: any, index: number) => (
                <img
                  key={index}
                  src={imageUtil.concatImgUrlWithoutForceHttps(_.imageUrl, 240, 0, 100, process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","))}
                  alt=""
                  onClick={() => {
                    reviewDetailSendClickTrack.Evaluate_CommentDetail_Picture({material_type: "1", skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}` })
                    reviewListSendClickTrack.Productdetail_Comment__Picture({skuid: `${skuId || '-100'}`, commentId: `${commentId || '-100'}`, material_type: "1" })
                    // setOpenImage(true);
                    preViewImageVideoFn(_?.imageUrl, 1);
                    setImageUrl(_?.imageUrl);
                    setPreviewParams({
                      currentUserOperation: commentOpts?.currentUserOperation,
                      anonymousFlag: commentOpts?.anonymousFlag,
                    })
                  }}
                />
              ))}
            </div>
          )}
          {/* 大图预览 */}
          {
            openImage && (
              <PreviewImageVideo
                open={openImage}
                isContent={true}
                content={content}
                imageUrl={imageUrl}
                nickName={newUserNickName}
                reportCommentParams={{skuId: skuId, ...reportReqParams, ...previewParams}}
                urlList={
                  [
                    ...(videoList || []).map((item: any) => ({ type: 0, url: item.videoUrl })),
                    ...(imageList || []).map((item: any) => ({ type: 1, url: item.imageUrl }))
                  ]
                }
                // anonymousFn={anonymousFn}
                closeView={closeReviewDetail}
              />
            )
          }
          {/* 评论底部详情 */}
          <div>
            {/* {anonymousFlag ? (<div style={{display: 'flex', alignItems: 'center', gap: "5px"}}><NoCheckPsd /><span style={{color: "#888"}}>Anonymous</span></div>) : <div></div>} */}
            <CommentBottomDetailOpts
              reportReqParams={reportReqParams}
              onComment={() => isHandleCommentClick && showReviewDetail()}
              commentItem={{ ...commentOpts, anonymousFlag , content, imageList, videoList}}
              anonymousFn={setAnonymousFn}
              deleteNotify={onCommentDelete}
            />
          </div>
          {/* 评论回复 */}
          {showReply && (
            <div className="comment-reply">
              <CustomTextarea value={replyContent} onChange={onTextareaChange} placeholder={"You may add any supplementary information in this section."} />
              <p className="opt" ref={currentRef}>
                <SubmitButton onClick={() => replyContent && submitReply()}>Submit</SubmitButton>
              </p>
            </div>
          )}
          {/* 对于评论回复的 二级评论列表 */}
          {showReplyList && (
            <>
              <SecondaryReplyList
                replyList={isLimitReplyCount ? replyList?.slice(0, limitReplyCount) : replyList}
                extraData={{ commentId, skuId }}
                customReplyList={customReplyList}
              />
              {showMoreReplyList && (
                <div className="view-more" onClick={() => showReviewDetail()}>
                  View all {commentNum} replies
                </div>
              )}
            </>
          )}
        </div>
        {/* Review Detail */}
        <IntlDialog
          onClose={closeReviewDetail}
          open={isOpenReviewDetail}
          title="Review details"
          sx={{
            "& .MuiDialog-paper": {
              overflowY: "hidden",
              maxHeight: "800px",
            },
          }}
          content={
            <>
              <div className="review-list-wrapper">
                {/* 评论详情 */}
                <CommentItem
                  comment={{ ...reviewDetailData, skuId }}
                  showCommentMedia={true}
                  showReplyList={true}
                  showReply={true}
                  isShowScoreStar={true}
                  isHandleCommentClick={false}
                  commentOpts={commentOpts}
                  reportReqParams={reportReqParams}
                />
                <div style={{ width: "100%", height: "55px", lineHeight: "55px", textAlign: "center", color: "#C2C4CC", fontSize: "14px" }}>
                  You&apos;re reached the end
                </div>
              </div>
            </>
          }
          width={800}
          showButtonAction={false}
        />
      </div>
    );
  },
);

export default CommentItem;
